@if (show) {
  <div class="dialog-box-container">
    <div class="dialog-box" [class.dialog-box--danger]="status === 'danger'">
      @if (status === 'danger') {
        <div class="dialog-danger-message">
          <i class="fa-light fa-circle-xmark" aria-hidden="true"></i>
          <p class="message-body">{{ message | translate: param }}</p>
        </div>
      } @else {
        <span class="message-header">{{ 'ATTENTION_TEXT' | translate }}</span>
        <p class="message-body">{{ message | translate: param }}</p>
      }
      <div class="flex-center dialog-actions">
        <button class="btn dialog-ok" [class.btn-primary]="status !== 'danger'" (click)="ok()">
          {{ okText | translate }}
        </button>
        @if (!hideCancel) {
          <button class="btn link-btn dialog-cancel" (click)="cancel()">{{ cancelText | translate }}</button>
        }
      </div>
    </div>
  </div>
}
